'use strict';

const $ = require('dibs-jquery-shim');
const {isPageType, pageTypes: {PAGE_TYPE}} = require('dibs-buyer-layout/src/entries/index');
const calloutHelper = require('../../../components/Callout/calloutHelper');
const calloutActions = require('../../../components/Callout/calloutActions');
const deviceTypeHelper = require('../../../global/utils/deviceTypeHelper');

const allowedPageType = function allowedPageType() {
    const allowedPages = [PAGE_TYPE.PDP, PAGE_TYPE.BROWSE, PAGE_TYPE.SEARCH, PAGE_TYPE.ATTRIBUTE];

    return isPageType(allowedPages);
};

/**
 * Checks condition for folder icon callout.
 * Opens callout if condition is satisfied.
 *
 * @return {Promise}
 */
const saveToFolderCalloutRule = function saveToFolderCalloutRule({ context }) {
    const type = calloutHelper.CALLOUT_TYPE_SAVE_TO_FOLDER;
    const canShowCallout = calloutHelper.canShowCallout({ type });
    const isMobile = deviceTypeHelper.isMobileOrTablet();

    const wrap = function(element) {
        if (element) {
            element = element.wrap('<div>').parent();
        }
        return element;
    };

    if (!canShowCallout || !allowedPageType() || isMobile) {
        return Promise.resolve();
    } else if (isPageType(PAGE_TYPE.PDP)) {
        context.executeAction(calloutActions.openCallout, { type });
        return Promise.resolve({ success: true, type });
    }

    const tooltipElement = $('#productsResults')
        .children()
        .first()
        .find('.js-folder-icon');
    calloutHelper.showSaveToFolderCallout({ context, tooltipElement: wrap(tooltipElement) });

    return Promise.resolve({ success: true, type });
};

module.exports = saveToFolderCalloutRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/saveToFolderCalloutRule.es.js